module.exports = __webpack_public_path__ + "img/205.e9691d74.png";